import { render } from "./BaseChecklist.vue?vue&type=template&id=0c48fe90"
import script from "./BaseChecklist.vue?vue&type=script&lang=js"
export * from "./BaseChecklist.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__